<template>
    <b-navbar toggleable="md" class="top-nav" :type="navbarType">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <div class="content-wrap">
          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
              <b-nav-item v-for="(itm,idx) in navItems" :key="idx":to="itm.to">{{ itm.name }}</b-nav-item>
            </b-navbar-nav>
            
            <user-auth />
            
          </b-collapse>
        </div>        
    </b-navbar>
</template>

<script>

import userAuth from '@/components/UserAuth.vue'

export default {
  name: 'topNav',
  props: {
    navbarType: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  components: {
    userAuth
  },
  computed: {
    isStandalone() {
      return process.env.VUE_APP_FORM_TYPE == 'standalone';
    },
    isTiga() {
      return process.env.VUE_APP_FORM_TYPE == 'tiga';
    },
    isTga() {
      return process.env.VUE_APP_FORM_TYPE == 'tga';
    },
    isPolFed() {
      return process.env.VUE_APP_FORM_TYPE == 'polfed';
    },
    navItems() {
      const start =  [
        {to: '/home', name: 'Home'},
        {to: '/makeaclaim', name: 'Make a claim'},
      ];
      
      let middle = [];
      if (this.isPolFed || this.isTiga || this.isTga) {
        middle = [{to:'/makeaclaim/resume',name:'Resume a claim'}]
      } else {
        middle = [{to:'/myclaims/inprogress',name:'Resume a claim'}]
      }

      const end = [
        {to: '/myclaims/list', name: 'Check status of a claim'},
        {to: '/contact', name: 'Contact Us'}
      ]

      return [...start,...middle,...end]
    }
  }
}
</script>



